// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__AQwdB","filesListContainer":"PosDisputesFiles_filesListContainer__M2NR0","filesButton":"PosDisputesFiles_filesButton__Kd0RG"};